import { FLAG_TYPE_ERROR } from '@atlassian/mpac-types';
const RUSSIA_ISO_CODE = 'RU';
const BELARUS_ISO_CODE = 'BY';
const BLACKLISTED_COUNTRIES = [RUSSIA_ISO_CODE, BELARUS_ISO_CODE];
const MESSAGE_TITLE = "We stand with Ukraine";
const MESSAGE_DESCRIPTION = 'We have a commitment to our customers to provide a trusted service. Hence, we are pausing the sale of all new software to Russia and Belarus.';
const MESSAGE_LINK = 'https://www.atlassian.com/blog/announcements/atlassian-stands-with-ukraine';
export const flagConfigForRussianUsers = {
  id: 'marketplace-app-install-blocked-region-denied-service',
  title: MESSAGE_TITLE,
  description: MESSAGE_DESCRIPTION,
  type: FLAG_TYPE_ERROR,
  isAutoDismiss: true,
  actions: [{
    content: 'Read the public blog',
    href: MESSAGE_LINK,
    target: '_blank'
  }]
};
export const isCountryBlacklisted = countryCode => BLACKLISTED_COUNTRIES.some(blacklistedCountry => blacklistedCountry === countryCode);